import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = sessionStorage.getItem('countdown_end');
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      return remaining > 0 ? remaining : 86369;
    }
    const end = Date.now() + 86369 * 1000;
    sessionStorage.setItem('countdown_end', end.toString());
    return 86369;
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) {
          const end = Date.now() + 86369 * 1000;
          sessionStorage.setItem('countdown_end', end.toString());
          return 86369;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="text-center" data-id="element-60">
      <div className="flex items-center justify-center gap-2 md:gap-4" data-id="element-61">
        <div className="bg-red-600 text-white rounded-lg px-4 py-3 min-w-[70px] md:min-w-[90px]" data-id="element-62">
          <span className="text-3xl md:text-5xl font-heading font-black tabular-nums" data-id="element-63">
            {pad(hours)}
          </span>
          <p className="text-xs mt-1 opacity-80" data-id="element-64">hs</p>
        </div>
        <span className="text-3xl md:text-5xl font-black text-red-600" data-id="element-65">:</span>
        <div className="bg-red-600 text-white rounded-lg px-4 py-3 min-w-[70px] md:min-w-[90px]" data-id="element-66">
          <span className="text-3xl md:text-5xl font-heading font-black tabular-nums" data-id="element-67">
            {pad(minutes)}
          </span>
          <p className="text-xs mt-1 opacity-80" data-id="element-68">min</p>
        </div>
        <span className="text-3xl md:text-5xl font-black text-red-600" data-id="element-69">:</span>
        <div className="bg-red-600 text-white rounded-lg px-4 py-3 min-w-[70px] md:min-w-[90px]" data-id="element-70">
          <span className="text-3xl md:text-5xl font-heading font-black tabular-nums" data-id="element-71">
            {pad(seconds)}
          </span>
          <p className="text-xs mt-1 opacity-80" data-id="element-72">seg</p>
        </div>
      </div>
    </div>;
}
;
' >';